import React, { useState, useEffect } from 'react';
import './Agregar_saldo.css';

const AgregarSaldo = () => {
  const [saldoIngresado, setSaldoIngresado] = useState('');
  const [metodoPago, setMetodoPago] = useState('');
  const [checkTerminos, setCheckTerminos] = useState(false);
  const [checkVerificacion, setCheckVerificacion] = useState(false);
  const [usuarioEmail, setUsuarioEmail] = useState('');
  const [mensajeFlow, setMensajeFlow] = useState('');
  const [mensajePago, setMensajePago] = useState('');
  const [loadingPago, setLoadingPago] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayCount, setOverlayCount] = useState(7);
  const [mensajeTransferencia, setMensajeTransferencia] = useState('');

  const SALDO_DEV_URL = process.env.REACT_APP_SALDO_DEV_URL;
  const AUTH_CREADOR_URL = process.env.REACT_APP_AUTH_CREADOR_URL;

  useEffect(() => {
    cargarUsuario();
  }, []);

  const cargarUsuario = async () => {
    try {
      const response = await fetch(`${AUTH_CREADOR_URL}/get_cuenta.php`, {
        method: 'GET',
        credentials: 'include'
      });
      const data = await response.json();
      if (data.success) {
        setUsuarioEmail(data.email);
      }
    } catch (err) {
      console.error('Error cargando usuario:', err);
    }
  };

  // Formatear valor numérico a formato peso chileno con puntos
  const formatearPeso = (valor) => {
    // Eliminar todo lo que no sea número
    const soloNumeros = valor.replace(/\D/g, '');
    if (soloNumeros === '') return '';
    // Formatear con puntos de miles
    const numero = parseInt(soloNumeros, 10);
    return '$' + numero.toLocaleString('es-CL');
  };

  const handleSaldoChange = (e) => {
    const valorRaw = e.target.value;
    // Si el usuario borra todo, dejar vacío
    if (valorRaw === '' || valorRaw === '$') {
      setSaldoIngresado('');
      return;
    }
    setSaldoIngresado(formatearPeso(valorRaw));
  };

const handleMetodoPagoChange = (e) => {
    const valor = e.target.value;
    setMetodoPago(valor);
    if (valor === 'flow') {
      setMensajeFlow('NO SE ENCUENTRA HABILITADA - MOMENTANEAMENTE - solo debes elegir transferencia');
      setMensajeTransferencia('');
    } else if (valor === 'transferencia') {
      setMensajeFlow('');
      setMensajeTransferencia('Contáctate con nosotros via WhatsApp o Telegram para indicar qué monto ingresaste, luego nosotros realizaremos un cálculo, DEBES indicar tu correo o usuario y sobre todo el voucher de pago, PENDIENTE A REVISION');
    } else {
      setMensajeFlow('');
      setMensajeTransferencia('');
    }
  };
  
const handlePagar = async () => {
    if (!saldoIngresado) {
      alert('Debes ingresar el saldo que deseas agregar.');
      return;
    }
    if (!metodoPago || metodoPago === 'flow') {
      alert('Debes seleccionar Transferencia como método de pago.');
      return;
    }
    if (!checkTerminos) {
      alert('Debes aceptar los Términos y Condiciones.');
      return;
    }
    if (!checkVerificacion) {
      alert('Debes confirmar que realizaste el proceso de verificación.');
      return;
    }

    const valorNumerico = parseInt(saldoIngresado.replace(/\D/g, ''), 10);
    setLoadingPago(true);
    setMensajePago('');

try {
      const response = await fetch(`${SALDO_DEV_URL}/PRUEBA_PAGO.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          saldo_anadido: valorNumerico,
          metodo_pago:   metodoPago
        })
      });

      let data = {};
      try { data = await response.json(); } catch(e) {}

      if (response.ok && data.success) {
        // Mostrar overlay y reiniciar campos
        setShowOverlay(true);
        setOverlayCount(7);
        setSaldoIngresado('');
        setMetodoPago('');
        setCheckTerminos(false);
        setCheckVerificacion(false);
        setMensajeFlow('');
        setMensajeTransferencia('');
        setMensajePago('PAGO PENDIENTE A REVICION');

        // Countdown de 7 segundos
        let contador = 7;
        const intervalo = setInterval(() => {
          contador -= 1;
          setOverlayCount(contador);
          if (contador <= 0) {
            clearInterval(intervalo);
            setShowOverlay(false);
          }
        }, 1000);

      } else {
        setMensajePago(data.message || 'Error al procesar el pago.');
      }
    } catch (err) {
      setMensajePago('Error de conexión con el servidor.');
    } finally {
      setLoadingPago(false);
    }
  };

return (
    <div style={{ width: '100%' }}>
    <div className="agregar-saldo-container">
      {showOverlay && (
        <div className="agregar-overlay">
          <div className="agregar-overlay-box">
            <p className="agregar-overlay-texto">PAGO PENDIENTE A REVISIÓN</p>
            <p className="agregar-overlay-contador">Cerrando en {overlayCount}s</p>
          </div>
        </div>
      )}
      <div className="agregar-saldo-content">
        <h1 className="agregar-saldo-titulo">PROCESO - AGREGAR SALDO :</h1>
        <hr className="agregar-saldo-linea" />

        <div className="agregar-saldo-texto-info">
          <p className="agregar-saldo-texto">
            Al momento de pagar se agregará un impuesto, el cual será calculado de forma automática mostrándote en los detalles del pago, ejemplo, si recargas $50.000, deberás cancelar $59.500, Pero en el saldo que se visualizará a tu favor será de $50.000, este proceso se debe realizar para transparentar el pago por el servicio en aspectos legales.
          </p>
          <p className="agregar-saldo-texto agregar-saldo-nota">
            <span className="texto-nota-label">Nota:</span> Verifica bien el saldo que deseas agregar, ya que no existe devolución del saldo que tengas a favor, calcula el plan que deseas, recuerda que el valor de los planes adqueridos, estan sujetos a cambios.
          </p>
        </div>

        {/* Campo: Saldo que deseas agregar */}
        <div className="agregar-campo-formulario">
          <label className="agregar-campo-label">Saldo que deseas agregar :</label>
          <input
            type="text"
            className="agregar-campo-input"
            value={saldoIngresado}
            onChange={handleSaldoChange}
            placeholder=""
            inputMode="numeric"
          />
        </div>

{/* Campo: Usuario */}
        <div className="agregar-campo-formulario">
          <label className="agregar-campo-label">Usuario :</label>
          <input
            type="text"
            className="agregar-campo-input"
            value={usuarioEmail}
            readOnly
          />
        </div>

        {/* Campo: Métodos de pago */}
        <div className="agregar-campo-formulario">
          <label className="agregar-campo-label">Métodos de pago :</label>
          <select
            className="agregar-campo-select"
            value={metodoPago}
            onChange={handleMetodoPagoChange}
          >
            <option value="">-- Selecciona --</option>
            <option value="transferencia">Transferencia</option>
            <option value="flow">Flow</option>
          </select>
        </div>
        {mensajeFlow && (
          <p style={{ color: '#8B0000', fontFamily: 'Arial Black', fontSize: '14px', marginBottom: '15px' }}>
            {mensajeFlow}
          </p>
        )}
        {mensajeTransferencia && (
          <div className="agregar-mensaje-transferencia">
            {mensajeTransferencia}
          </div>
        )}

        {/* Checkbox: Términos y Condiciones */}
        <div className="agregar-check-container">
          <label className="agregar-check-label">
            <input
              type="checkbox"
              className="agregar-checkbox"
              checked={checkTerminos}
              onChange={(e) => setCheckTerminos(e.target.checked)}
            />
            <span className="agregar-check-texto">
              Yo he leído conforme los <strong>TÉRMINOS Y CONDICIONES</strong> del sitio web Ulalaaa y los acepto de forma íntegra.
            </span>
          </label>
        </div>

        {/* Checkbox: Verificación */}
        <div className="agregar-check-container">
          <label className="agregar-check-label">
            <input
              type="checkbox"
              className="agregar-checkbox"
              checked={checkVerificacion}
              onChange={(e) => setCheckVerificacion(e.target.checked)}
            />
            <span className="agregar-check-texto">
              Realicé el proceso de verificación para demostrar mi mayoría de edad, por ende cumplo los requisitos para poder publicar mi anuncio, en este sitio publicitario.
            </span>
          </label>
        </div>

{/* Botón PAGAR */}
        <div className="agregar-boton-container">
          <button className="btn-pagar" onClick={handlePagar} disabled={loadingPago}>
            {loadingPago ? 'PROCESANDO...' : 'PAGAR'}
          </button>
        </div>

        {/* Mensaje resultado */}
        {mensajePago && (
          <p style={{
            fontFamily: 'Arial Black',
            fontSize: '20px',
            color: mensajePago === 'PAGO PENDIENTE A REVICION' ? '#006600' : '#8B0000',
            textAlign: 'center',
            marginTop: '20px',
            fontWeight: '900'
          }}>
            {mensajePago}
          </p>
        )}
</div>
    </div>

      {/* Footer */}
      <footer className="home-footer">
        <div className="home-footer-top">
          <div className="home-footer-redes">
            <a href="https://www.instagram.com/ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.tiktok.com/@ulalaaaoficial2" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-tiktok"></i>
            </a>
            <a href="https://www.youtube.com/@ulalaaaoficial" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-youtube"></i>
            </a>
            <a href="https://wa.me/56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-whatsapp"></i>
            </a>
            <a href="#" className="home-footer-social-link">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{width:'22px',height:'22px'}}>
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.746l7.73-8.835L1.254 2.25H8.08l4.259 5.63 5.905-5.63zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
            <a href="https://t.me/+56929674732" target="_blank" rel="noopener noreferrer" className="home-footer-social-link">
              <i className="fab fa-telegram"></i>
            </a>
          </div>
          <div className="home-footer-logo">
            <img
              src={`${process.env.REACT_APP_UPLOADS_URL}/logotipo_new8.jpg`}
              alt="Ulalaaa Logo"
              className="home-footer-logo-img"
            />
          </div>
          <div className="home-footer-legal-links">
            <a href="/textos-legales#terminos" className="home-footer-legal-btn">Información Legal - Términos y Condiciones</a>
            <a href="/textos-legales#privacidad" className="home-footer-legal-btn">Política de Privacidad</a>
          </div>
        </div>
        <div className="home-footer-texto">
          Ulalaaa, es un sitio web exclusivo para mayores de 18 años, tanto para las personas publicadas como las que lo visitan, las personas publicadas son verificadas de forma rigurosa, el cual han dado su consentimiento para ser publicadas, este sitio no es una agencia, es solo un medio publicitario que no interviene con ninguna relación laboral con las personas publicadas.
        </div>
        <div className="home-footer-copyright">
          ©2026 Ulalaaa - Todos los derechos Reservados.
        </div>
      </footer>
    </div>
  );
};

export default AgregarSaldo;
